// Notification Types - matches Prisma enum (for NotificationConfig)
export var NotificationType;
(function (NotificationType) {
    NotificationType["BIRTHDAY_REMINDER"] = "BIRTHDAY_REMINDER";
    NotificationType["ENROLLMENT_EXPIRY_REMINDER"] = "ENROLLMENT_EXPIRY_REMINDER";
    NotificationType["TRIAL_CLASS_REMINDER"] = "TRIAL_CLASS_REMINDER";
    NotificationType["PAYMENT_DUE_REMINDER"] = "PAYMENT_DUE_REMINDER";
    NotificationType["CLASS_REMINDER"] = "CLASS_REMINDER";
})(NotificationType || (NotificationType = {}));
// Sent Notification Types - used by SentNotification table for idempotency tracking
// Uses lowercase snake_case to match database values
export var SentNotificationType;
(function (SentNotificationType) {
    SentNotificationType["BIRTHDAY_REMINDER"] = "birthday_reminder";
    SentNotificationType["ENROLLMENT_EXPIRY_REMINDER"] = "enrollment_expiry_reminder";
    SentNotificationType["TRIAL_CLASS_REMINDER"] = "trial_class_reminder";
})(SentNotificationType || (SentNotificationType = {}));
// Notification Channels
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["EMAIL"] = "EMAIL";
    NotificationChannel["SMS"] = "SMS";
    NotificationChannel["WHATSAPP"] = "WHATSAPP";
})(NotificationChannel || (NotificationChannel = {}));
//# sourceMappingURL=Notification.js.map